import {
  ASSET_CLASSES,
  ASSET_CLASS_INVESTMENT_TYPES,
  AssetClass,
} from "@api/v1/hooks/performance/assetClasses";

// The asset classes at least one of the investments belongs to.
export const assetClassesIn = (
  investments: { type?: string }[]
): AssetClass[] => {
  const types = new Set(investments.map((investment) => investment.type));
  return ASSET_CLASSES.filter((assetClass) =>
    ASSET_CLASS_INVESTMENT_TYPES[assetClass].some((type) => types.has(type))
  );
};
